import React, { useEffect , useState} from "react";
import "./Test.css";
import ScrollReveal from "scrollreveal";

const Test = () => {


  const images = [
    "images/cabinet/vaultx3.png",
    "images/cabinet/solar.png",
    "images/cabinet/cosmic.png",
    "images/cabinet/vaultx4.png",
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 4000); // 4 seconds

    return () => clearInterval(interval);
  }, [images.length]);


  return (
    <>
      {/* HEADER / NAV */}
      <header id="home">
  

        {/* MAIN SECTION */}
          <section className="main">
      <div className="left">
        <h1>Build Your Dream PC — Custom or Prebuilt, We Deliver Perfection</h1>
        <p>
          Choose from high-performance custom PCs or premium prebuilt machines.
          Optimized for gaming, editing, coding, streaming — everything you need
          in one place.
        </p>
        <div className="main_btn">
          <button className="btn btn-secondary">explore builds</button>
          <button className="btn btn-primary">customize now</button>
        </div>
      </div>

      <div className="right">
        <img
          src={images[index]}
          alt="high performance pc"
           style={{ width: "550px", height: "550px", objectFit: "cover" }}
        />
      </div>
    </section>
      </header>

      {/* ABOUT */}
      <section className="sec" id="about">
        <div className="head">
          <h3 className="sub_heading">About Us</h3>
          <h1 className="heading">Your Trusted Custom PC & Prebuilt Experts</h1>
        </div>

        <div className="boxes">
          <div className="box">
            <span><i className="ri-global-fill"></i></span>
            <h4>Custom PC Builds</h4>
            <p>
              Fully customized builds tailored to your needs — gaming, editing,
              engineering, AI and more.
            </p>
          </div>
          <div className="box">
            <span><i className="ri-database-2-fill"></i></span>
            <h4>Store Your Configurations</h4>
            <p>
              Save your build details securely and revisit your configurations
              whenever you want.
            </p>
          </div>
          <div className="box">
            <span><i className="ri-key-2-fill"></i></span>
            <h4>Secure & Reliable</h4>
            <p>
              Every PC is tested for thermal performance, stability, and long-term
              durability before delivery.
            </p>
          </div>
        </div>
      </section>
<div className="sec">
        <div className="head">
            <h3 className="sub_heading">Work Flow</h3>
            <h1 className="heading">Our PC Building Process</h1>
        </div>

  <div className="process_wrapper">
    <div className="process_box">
      <div className="icon_circle">
        <i className="ri-shopping-bag-3-line"></i>
      </div>
      <h4>Components Selection</h4>
    </div>

    <div className="arrow_line"></div>

    <div className="process_box">
      <div className="icon_circle">
        <i className="ri-cpu-line"></i>
      </div>
      <h4>PC Assembly</h4>
    </div>

    <div className="arrow_line"></div>

    <div className="process_box">
      <div className="icon_circle">
        <i className="ri-windows-line"></i>
      </div>
      <h4>OS Installation</h4>
    </div>

    <div className="arrow_line"></div>

    <div className="process_box">
      <div className="icon_circle">
        <i className="ri-dropbox-line"></i>
      </div>
      <h4>Packing</h4>
    </div>
  </div>
</div>

      {/* SERVICES */}
      <section className="sec" id="services">
        <div className="head_1">
          <h3 className="sub_heading">Our Services</h3>
          <h1 className="heading">Premium PC Services & Hardware Solutions</h1>
          <p className="para">
            From component selection to final assembly — we offer everything needed
            to get your perfect PC running smoothly.
          </p>
                </div>

        <div className="Service_box">
          <div className="left_box">
            <p>
              We assemble PCs with premium care, from cable management to thermal
              optimization and BIOS tuning.
            </p>
            <li><i className="ri-arrow-right-s-fill"></i>custom pc assembly</li>
            <li><i className="ri-arrow-right-s-fill"></i>stress & benchmark testing</li>
            <li><i className="ri-arrow-right-s-fill"></i>performance optimization</li>
            <button className="btn btn-primary">learn more</button>
          </div>

          <div className="right_box">
            <ul>
              <li>
                <span><i className="ri-price-tag-3-fill"></i></span>
                <div>
                  <h4>High-Performance Builds</h4>
                  <p>Designed for gamers, creators & professionals.</p>
                </div>
              </li>
              <li>
                <span><i className="ri-wallet-fill"></i></span>
                <div>
                  <h4>Top Component Brands</h4>
                  <p>Choose CPUs, GPUs, SSDs, cooling & more.</p>
                </div>
              </li>
              <li>
                <span><i className="ri-customer-service-fill"></i></span>
                <div>
                  <h4>24/7 Technical Support</h4>
                  <p>We're always available to help you.</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
           <div className="video-row">
  <div className="video-container">
    <video width="100%" height="auto" autoPlay muted loop>
      <source src="images/cabinet/video1.mp4" type="video/mp4" />
    </video>
  </div>

  <div className="video-container">
    <video width="100%" height="auto" autoPlay muted loop>
      <source src="images/cabinet/video2.mp4" type="video/mp4" />
    </video>
  </div>

  <div className="video-container">
    <video width="100%" height="auto" autoPlay muted loop>
      <source src="images/cabinet/video3.mp4" type="video/mp4" />
    </video>
  </div>
</div>
      </section>

      {/* ROUTE / FEATURES */}
      <section className="sec route" id="route">
        <div className="head_1">
          <h3 className="sub_heading">What We Offer</h3>
          <h1 className="heading">Powerful, Reliable & Future-Ready PCs</h1>
        </div>

        <div className="boxes_1">
          <div className="box_1"><span><i className="ri-price-tag-3-fill"></i></span><h4>Best Pricing</h4></div>
          <div className="box_1"><span><i className="ri-money-rupee-circle-fill"></i></span><h4>Dedicated Support</h4></div>
          <div className="box_1"><span><i className="ri-bank-card-fill"></i></span><h4>Flexible EMI Options</h4></div>
          <div className="box_1"><span><i className="ri-ship-2-fill"></i></span><h4>Air & Liquid Cooling</h4></div>
          <div className="box_1"><span><i className="ri-customer-service-2-fill"></i></span><h4>24/7 Assistance</h4></div>
          <div className="box_1"><span><i className="ri-car-fill"></i></span><h4>Expert Technicians</h4></div>

          {/* Replace YOUR_IMAGE_LINK with a schematic or diagram related to PC flow/assembly */}
          



          <img src="images/cabinet/vaultx4.png" alt="PC flow diagram" />
        </div>
      </section>

      {/* CONTACT */}
      <section className="sec contact" id="contact">
        <div className="head_1">
          <h3 className="sub_heading">Contact Us</h3>
          <h1 className="heading">Get Your PC Built Today</h1>
        </div>

        <div className="box_2">
          <button className="btn btn-secondary">contact us</button>
        </div>
      </section>

      {/* FOOTER */}
      <footer>
        <div className="sec footer">
          <div className="footer_col">
            <h4>Support</h4>
            <ul className="footer_links">
              <li><a href="#">security</a></li>
              <li><a href="#">contact</a></li>
              <li><a href="#">help center</a></li>
              <li><a href="#">warranty policy</a></li>
              <li><a href="#">sitemap</a></li>
            </ul>
          </div>

          <div className="footer_col">
            <h4>Products</h4>
            <ul className="footer_links">
              <li><a href="#">gaming pcs</a></li>
              <li><a href="#">workstations</a></li>
              <li><a href="#">prebuilt pcs</a></li>
              <li><a href="#">components</a></li>
            </ul>
          </div>

          <div className="footer_col">
            <h4>About</h4>
            <ul className="footer_links">
              <li><a href="#">insurance</a></li>
              <li><a href="#">resources</a></li>
              <li><a href="#">terms</a></li>
            </ul>
          </div>

          <div className="footer_col">
            <h4>Explore</h4>
            <ul className="footer_links">
              <li><a href="#">intel builds</a></li>
              <li><a href="#">amd builds</a></li>
              <li><a href="#">nvidia gpus</a></li>
              <li><a href="#">cooling systems</a></li>
            </ul>
          </div>
        </div>

        <div className="sec footer_bar">
          <h4>CloudVU</h4>
          <p>© 2025 CloudVU Store — All Rights Reserved</p>
          <ul className="footer_socials">
            <li><a href="#"><i className="ri-facebook-fill"></i></a></li>
            <li><a href="#"><i className="ri-twitter-fill"></i></a></li>
            <li><a href="#"><i className="ri-instagram-fill"></i></a></li>
          </ul>
        </div>
      </footer>
    </>
  );
};

export default Test;